import Head from "next/head";
import React from "react";

export default ({ children }) => (
  <div className="PageContainer">
    <Head>
      <title>Andy Matuschak</title>
      <meta name="author" content="Andy Matuschak" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta charSet="utf-8" />
    </Head>
    {children}
  </div>
);
